import React from "react";
import FaqSection from "components/FaqSection";
import GuideSection from "components/GuideSection";
import Link from "next/link";
import SideBar from "./SideBar";
import Section from "components/Section";
import {
  HeaderH2,
  HeaderH1,
  Text,
  NextButton,
  ImageBlock,
} from "components/TextBlocks";

function TeamDashboard(props) {
  const keyCss = {
    fontSize: "1rem",
    fontFamily: "menlo, consolas, monospace",
    border: "1px solid #DDDDDD",
    borderRadius: "5px",
    boxShadow: "0 4px 8px -1px rgba(201,204,208,0.90)",
    backgroundColor: "#FFF",
    paddingTop: "4px",
    paddingBottom: "4px",
    paddingLeft: "7px",
    paddingRight: "6px",
  };
  return (
    <Section
      id="pricing"
      color={props.color}
      size={props.size}
      backgroundImage={props.backgroundImage}
      backgroundImageOpacity={props.backgroundImageOpacity}
    >
      <div
        className="container"
        style={{ maxWidth: "800px", paddingTop: "2rem", paddingBottom: "4rem" }}
      >
        <HeaderH1>The Team dashboard</HeaderH1>
        <Text>
          If are on the Pro plan you will gain access to the team dashboard. It
          can be found by going to{" "}
          <a href="/settings/team" style={{ textDecoration: "underline" }}>
            {" "}
            settings/team
          </a>
          . Start by creating a team and giving it a name. You can then redeem
          slots for team-members. This will be done by entering a valid code,
          this in turn gives you the ability to invite team members by email.
        </Text>
        <ImageBlock
          src={"/guide/team_change_name.png"}
          width={883}
          height={811}
          quality={100}
          alt={"Change team name"}
        />

        <Text>
          Once a member is invited they have to sign in, or sign up(if they have
          not done so already) into tabExtend web app. A popup will appear with
          a option to accept or deny the invitation. If they accept they will
          join your team and be upgraded to the Pro plan as long as they are
          still on your team.
        </Text>
        <ImageBlock
          src={"/guide/team_invite.png"}
          width={883}
          height={811}
          quality={100}
          alt={"Invite team-member"}
        />
        <Text>
          If you are invited to a team and don't see the popup with the
          invitation, go to{" "}
          <a href="/dashboard" style={{ textDecoration: "underline" }}>
            account/overview
          </a>
          . If you experience any other issues, please don't hesitate to reach
          out to the support and we will help out.
        </Text>
        {/* <NextButton
        cta={"Create notes/to-dos"}
        textColor={"#565D65"}
        bg={"#EBECED"}
        page={"/guide/create-note"}
      /> */}
      </div>
    </Section>
  );
}

//TODO
//TeamDashboard.Layout = TeamDashboard;

export default TeamDashboard;
